module.exports = __webpack_public_path__ + "assets/img/组 164@2x.09f1d4ff.png";